module.exports = new __parcel__URL__("name_screen_btn_disabled.65a487e5.png").toString();